// Date / time formatting helpers shared across components.

// Clamp an operator-entered /loop cadence to the server-enforced [30, 3600] range
// (mirrors the LoopIntervalRequest bound) so the live loop-interval control never POSTs
// a value the backend will 422. NaN / non-finite → the 60s main-agent default.
export function clampLoopSeconds(value: number): number {
  if (!Number.isFinite(value)) return 60;
  return Math.min(3600, Math.max(30, Math.round(value)));
}

export function fmtAgo(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso).getTime();
  if (isNaN(d)) return "—";
  const secs = Math.floor((Date.now() - d) / 1000);
  if (secs < 5) return "now";
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

export function fmtClock(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toISOString().slice(11, 19);
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toISOString().slice(0, 19).replace("T", " ") + " UTC";
}

export function fmtShortSha(sha: string | null | undefined): string {
  if (!sha) return "—";
  return sha.slice(0, 7);
}

/** Format a future ISO timestamp as "in Xm" / "in Xh Ym" / "expired".
 * Use for rate_limited_until and other deadline fields (unlike fmtAgo which is past-only). */
export function fmtIn(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso).getTime();
  if (isNaN(d)) return "—";
  const secs = Math.floor((d - Date.now()) / 1000);
  if (secs <= 0) return "expired";
  if (secs < 60) return `in ${secs}s`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `in ${mins}m`;
  const hours = Math.floor(mins / 60);
  return `in ${hours}h ${mins % 60}m`;
}
